/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react'
import Button from '@mui/material/Button'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import ReferenceImage from './ReferenceImage.jsx'
import { clearFormStatus } from '../../../irmlib/src/redux'
// import { closeGeneralDialog, openGeneralDialog } from '../../../irmlib/src/containers/GeneralDialog.jsx'
// import { Box } from '@material-ui/core'
// import Camera from 'react-html5-camera-photo'
// import { clearBusy, setBusy } from '../../../irmlib/src/containers/GlobalBusyCursor.jsx'
import { CancelButton } from '../../../irmlib/src/components/FormControls/Button.jsx'
import { XDivider } from '../../../irmlib/src/styles/index.js'

// Define styled component outside of the functional component
const TextButton = styled(Button)`
  && {
    width: 19vw;
    // padding: 17px 0 0 0;
    justify-content: flex-start;
    padding-left: 0
  }
`
const NameLabel = styled.label`
    display: flex;
    width: 12vw;
    justify-content: left;
    color: #2E8B57;
`
// const ErrorLabel = styled.label`
//     display: flex;
//     justify-content: flex-start;
//     color: red;
//     font-size: 11px;
//     margin-right: 10px;
// `

// Function to check if the file size exceeds the specified limit dynamically
export const doesFileSizeExceed = (fileSize, maxFileSize) => {
  if (fileSize > maxFileSize) {
    return true
  } else {
    return false
  }
}

export const InputFileUploadButton = (props) => {
  const { t } = useTranslation()
  const { onImageCapture, error, setError, maxSize, allowedFormats, prevRefImage, resetTrigger, changeRefText, setCameraRef } = props
  const textChange = changeRefText || false
  const addRefImg = prevRefImage || null
  const [selectedImageLabel, setSelectedImageLabel] = useState(null)
  const [openDialog, setOpenDialog] = useState(false)
  const showRef = useRef(false)
  const [, forceRender] = useState(0)
  const isMountedRef = useRef(true) // Add mount tracking ref
  
  // Track component mount status
  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
    }
  }, [])

  const updateRefState = (val) => {
    if (!isMountedRef.current) return // Check before state update
    showRef.current = val
    forceRender(v => v + 1)
  }

  useEffect(() => {
    if (resetTrigger > 0) {
      // Use a ref or check if component is still mounted before calling
      if (onImageCapture && isMountedRef.current) {
        onImageCapture(null)
      }
      if (isMountedRef.current) {
        setSelectedImageLabel(null)
      }
      if (isMountedRef.current) {
        clearFormStatus()
      }
    }
  }, [resetTrigger, onImageCapture])

  const handleCancel = () => {
    if (!isMountedRef.current) return
    setOpenDialog(false)
    updateRefState(false)
    if (setCameraRef) {
      setCameraRef(prev => prev + 1)
    }
  }

  return (
    <div>
      <TextButton
        onClick={() => setOpenDialog(true)}
        component='label'
        role={undefined}
        tabIndex={-1}
      >{textChange ? t('buttons.ChangeReferanceImage') : t('buttons.addReference')}
      </TextButton>
      <ReferenceImage
        open={openDialog}
        onClose={handleCancel}
        setSelectedImageLabel={setSelectedImageLabel}
        maxSize={maxSize}
        updateRefState={updateRefState}
        showEditScreen={showRef.current}
        allowedFormats={allowedFormats}
        onImageCapture={onImageCapture}
      />
      {selectedImageLabel || addRefImg
        ? <NameLabel>{selectedImageLabel || addRefImg}</NameLabel>
        : null}
    </div>
  )
}
InputFileUploadButton.propTypes = {
  onImageCapture: PropTypes.func,
  error: PropTypes.string,
  setError: PropTypes.func.isRequired
}

InputFileUploadButton.defaultProps = {
  onImageCapture: null,
  error: null,
  setError: () => { }
}